import { render, staticRenderFns } from "./SubEmpresaDashboardContratos.vue?vue&type=template&id=a032c03c&lang=pug"
import script from "./SubEmpresaDashboardContratos.vue?vue&type=script&lang=js"
export * from "./SubEmpresaDashboardContratos.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaDashboardContratos.vue?vue&type=style&index=0&id=a032c03c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports